import { identity, omit, pickBy } from 'lodash';

import UseIgnoreUndefinedObject from './useIgnoreUndefinedObject';
import { appApi } from 'configs/variables';
import axios from 'axios';

export default function useHttpClient() {
  const { remove } = UseIgnoreUndefinedObject();
  const getParse = localStorage.getItem('user-store') || null;
  const { accessAuthen = {} } = JSON.parse(getParse);

  const https = (em) => {
    return Promise.resolve(em);
  };

  const headers = (contentType = 'application/json') => ({
    Authorization: accessAuthen.access_token,
    'Content-Type': contentType,
  });

  const headersNoAuth = (contentType = 'application/json') => ({
    'Content-Type': contentType,
  });

  const urls = (url, params = null) => {
    let endpoints = url.startsWith('http') ? url : appApi + url;
    if (params) {
      const prs = pickBy(params, identity);
      const queryParams = new URLSearchParams(prs).toString();
      endpoints = endpoints + `?${queryParams}`;
    }
    return endpoints;
  };

  const bodies = (payload, { ignoreEmpty }) => JSON.stringify(ignoreEmpty ? remove(payload) : payload);

  const get = async (options, hasAuth = true) => {
    const fn = await fetch(urls(options.url, options?.params), {
      headers: hasAuth ? headers() : headersNoAuth(),
      method: 'GET',
      ...omit(options, ['url']),
    }).then((res) => res.json());

    return https(fn);
  };

  const mutate = async (options, methods, hasAuth = true) => {
    const ignoreEmpty = !options?.acceptEmpty;
    const fn = await fetch(urls(options.url, options?.params), {
      headers: hasAuth ? headers() : headersNoAuth(),
      method: methods,
      body: bodies(options.payload, { ignoreEmpty }),
    }).then((res) => {
      const responseType = options?.responseType || 'json';
      if (responseType === 'blob') {
        return res.blob();
      } else {
        return res.json();
      }
    });

    if (options?.responseType === 'blob') {
      return Promise.resolve(fn);
    } else {
      return https(fn);
    }
  };

  const deletes = async (options) => {
    const fn = await fetch(urls(options.url, options?.params), {
      headers: headers(),
      method: 'DELETE',
    }).then((res) => res.json());

    return https(fn);
  };

  const directive = async (props) => {
    const options = {
      ...props,
      data: props?.body || {},
    };

    const response = await axios(options);
    return response.data;
  };

  const formData = async (options, hasAuth = true) => {
    const initFormdata = new FormData();

    options.payload.forEach((ss) => {
      if (ss.type === 'file') {
        initFormdata.append('file', ss.value, ss.name);
      } else if (ss.type === 'files') {
        ss.value.forEach((k) => {
          initFormdata.append('files', k);
        });
      } else {
        initFormdata.append(ss.type || 'text', ss.value);
      }
    });

    // ไม่ set Content-Type เพื่อให้ browser generate boundary ใน multipart/form-data อัตโนมัติ
    const authHeaders = hasAuth ? { Authorization: accessAuthen.access_token } : {};

    // Timeout wrapper สำหรับ fetch
    const fetchWithTimeout = (url, fetchOptions, timeout = 120000) => {
      return Promise.race([
        fetch(url, fetchOptions),
        new Promise((resolve, _reject) =>
          setTimeout(() => resolve(Promise.reject(new Error('Upload timeout - กรุณาลองใหม่อีกครั้ง'))), timeout)
        ),
      ]);
    };

    const fn = await fetchWithTimeout(
      urls(options.url, options?.params),
      {
        headers: authHeaders,
        method: 'POST',
        body: initFormdata,
      },
      options.timeout || 120000
    ).then((res) => res.json());

    return https(fn);
  };

  return {
    token: accessAuthen?.access_token || undefined,
    get,
    getNoAuth: (options) => get(options, false),
    post: (options) => mutate(options, 'POST'),
    postNoAuth: (options) => mutate(options, 'POST', false),
    put: (options) => mutate(options, 'PUT'),
    putNoAuth: (options) => mutate(options, 'PUT', false),
    patch: (options) => mutate(options, 'PATCH'),
    patchNoAuth: (options) => mutate(options, 'PATCH', false),
    deletes,
    directive,
    formData,
    formDataNoAuth: (options) => formData(options, false),
  };
}
